//store
import { observable } from 'mobx';
import prompt from './prompt'
//config
import config from '../config';
import profile from './profile';
//plugin
import clipboard from 'clipboard-polyfill';
import axios from 'axios';


class Events {
  @observable newEvent = {
    name: '',
    type: '',
    url: '',
    eventAPIKey: ''
  };
  @observable list = [];
  @observable loading = true;
  addEvent(eventAPIKey) {
    //generater url
    this.newEvent.url = `http:${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${this.newEvent.name}`;
    //update eventAPIKey
    this.newEvent.eventAPIKey = eventAPIKey;
    //push event to eventList
    this.list.push(this.newEvent);
    //initial newEvent
    this.newEvent = {};
    prompt.message('事件創建成功...');
  }
  fetchEvent() {
    var self = this;
    self.loading = true;
    axios.defaults.withCredentials = true;
    axios.get(`${config.env.server}/api/state`)
      .then(function (response) {
        if (response.data === 'Logged') {
          axios.get(`${config.env.server}/api/profile`)
            .then(function (res) {
              axios.get(`${config.env.server}/iot/data/apikey/${res.data.apiKey}/event`)
                .then(function (eventList) {
                  self.list = [];
                  eventList.data.map(x => self.list.push(x));
                  self.loading = false;
                })
                .catch(function (error) {
                  console.log(error);
                })
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  fetchData(eventName) {
    var eventNameList = [];
    this.list.map((x) => (eventNameList.push(x.name)));
    var targetEventIndex = eventNameList.indexOf(eventName);
    let self = this;
    // axios.defaults.withCredentials = true;
    axios.get(`${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${eventName}`)
      .then(function (response) {
        self.list[targetEventIndex].data = response.data.data[0];
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  copyEventUrl(eventName) {
    var eventNameList = [];
    this.list.map((x) => (eventNameList.push(x.name)));
    var targetEventIndex = eventNameList.indexOf(eventName);
    clipboard.writeText(this.list[targetEventIndex].url);
  }
  copyEventAPIKey(eventName) {
    var eventNameList = [];
    this.list.map((x) => (eventNameList.push(x.name)));
    var targetEventIndex = eventNameList.indexOf(eventName);
    clipboard.writeText(this.list[targetEventIndex].eventAPIKey);
  }
  checkDuplicateEvent(eventName) {
    //get name list
    var eventNameList = [];
    this.list.map((x) => (eventNameList.push(x.name)));
    var result = eventNameList.includes(eventName);
    return result;
  }
  generateUrl(eventName) {
    //get name list
    var eventNameList = [];
    this.list.map((x) => (eventNameList.push(x.name)));
    var targetEventIndex = eventNameList.indexOf(eventName);
    var targetUrl = this.list[targetEventIndex].url;
    return targetUrl;
  }
  getAPIKey(eventName) {
    //get name list
    var eventNameList = [];
    this.list.map((x) => (eventNameList.push(x.name)));
    var targetEventIndex = eventNameList.indexOf(eventName);
    var targetEventAPIKey = this.list[targetEventIndex].eventAPIKey;
    return targetEventAPIKey;
  }
  removeEvent(eventName) {
    prompt.message('事件刪除中,請稍等...', null);
    let self = this;
    //remove event from database
    // axios.defaults.withCredentials = true;
    axios.delete(`${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${eventName}`)
      .then(function (response) {
        if (response.data == 'EVENT DELETE' && response.status === 200) {
          //get name list
          var eventNameList = [];
          self.list.map((x) => (eventNameList.push(x.name)));
          var targetEventIndex = eventNameList.indexOf(eventName);
          //rm event
          self.list.splice([targetEventIndex], 1);
          prompt.message('事件刪除成功.');
        } else {
          prompt.message('刪除失敗,請稍後再試.')
        }
      })
      .catch(error => console.log(error))
  }
  emptyEvent() {
    this.list = [];
  }
}
var events = window.events = new Events;

export default events;



// WEBPACK FOOTER //
// ./src/store/events.js